import { fetchVaultExportPages } from '@/lib/librarian/api';
import { initializeVault } from '@/lib/librarian/initializeVault';

export async function exportVaultBundle(knowledgeBaseId: string) {
  const vault = await initializeVault(knowledgeBaseId);
  const pages = await fetchVaultExportPages(vault.id);

  const bundle = pages
    .sort((a, b) => a.path.localeCompare(b.path))
    .map(
      (page) =>
        [`--- ${page.path} ---`, page.content_markdown, ''].join('\n')
    )
    .join('\n');

  return {
    vault,
    pages,
    fileName: `vault-${knowledgeBaseId}-${new Date().toISOString().slice(0, 10)}.md`,
    content: bundle,
  };
}